import { GridProps } from "@mui/material/Grid/Grid";
import React, { ReactNode } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useNavigation } from "@refinedev/core";

export function GraphicalDashboardCard(
  props: {
    gridProps: Partial<GridProps>;
    title: ReactNode;
    resource: string;
  } & React.PropsWithChildren<{}>
) {
  const navigate = useNavigation();

  return (
    <Grid item {...props.gridProps}>
      <Box
        sx={{ background: "white" }}
        padding={2}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        borderRadius={2}
        height={"100%"}
        onClick={() => navigate.list(props.resource)}
      >
        <Box width={"100%"} display={"flex"} flexDirection={"row"}>
          <Typography
            variant={"h5"}
            textAlign={"left"}
            fontWeight={700}
            width={"100%"}
            marginBottom={1}
          >
            {props.title}
          </Typography>
        </Box>
        <Box marginY="auto">{props.children}</Box>
      </Box>
    </Grid>
  );
}
